import { store } from "../../../engine/modules/core/store";

export function cleanupGizmo(object) {
  if (!object) return;

  if (object._gizmoControl) {
    object._gizmoControl.detach();
    if (store?.scene) {
      store.scene.remove(object._gizmoControl);
      if (object._gizmoCube) {
        store.scene.remove(object._gizmoCube);
      }
    }
    if (object._gizmoKeydown) {
      window.removeEventListener("keydown", object._gizmoKeydown);
    }
    object._gizmoControl =
      object._gizmoCube =
      object._gizmoKeydown =
      object._gizmoWhich =
      object._gizmoInitialVector =
      object._isDragging =
      object._currentMode =
        null;
  }

  if (object._transformControl) {
    object._transformControl.detach();
    if (store?.scene) {
      store.scene.remove(object._transformControl);
    }
    object._transformControl = null;
  }
  
  if (object._transformControlHelperCube) {
    if (store?.scene) {
      store.scene.remove(object._transformControlHelperCube);
    }
    object._transformControlHelperCube = null;
  }
  
  if (object._activeControl) {
    object._activeControl.detach();
    if (store?.scene) {
      store.scene.remove(object._activeControl);
    }
    object._activeControl = null;
  }
  
  if (object._offsetControls) {
    object._offsetControls.detach();
    if (store?.scene) {
      store.scene.remove(object._offsetControls);
    }
    object._offsetControls = null;
  }
  
  if (object._offsetControlsHelperCube) {
    if (store?.scene) {
      store.scene.remove(object._offsetControlsHelperCube);
    }
    object._offsetControlsHelperCube = null;
  }
}
